export default (siteName) => [
    {
        path: 'accounting-summary',
        name: 'accounting-summary',
        component: () => import('../../components/dashboard/Accounting/AccountingSummary/indexPage.vue'),
        meta: {
            title: `帳務匯總表${siteName}`,
            activeMenu: 'accounting',
        },
    },
    {
        path: 'accounting-summary/:sno',
        name: 'accounting-summary-edit',
        component: () => import('../../components/dashboard/Accounting/AccountingSummary/EditPage.vue'),
        meta: {
            title: `帳務匯總表-編輯傳票${siteName}`,
            activeMenu: 'accounting',
        },
    },
    {
        path: 'accounting-summary/print/',
        name: 'accounting-summary-print',
        component: () => import('../../components/dashboard/Accounting/AccountingSummary/PrintPage.vue'),
        meta: {
            title: `帳務匯總表-列印${siteName}`,
            activeMenu: 'accounting',
        },
    },
];
